import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { ModalActionTypes } from './action-types';
import { ModalMutationTypes } from './mutation-types';
import { ModalFiltroFuncionariosParams } from "@/enums/eTipoPesquisaFiltroFuncionarios";
import { ModalFiltroEstudantesParams } from '@/enums/eTipoPesquisaFiltroEstudantes';
import { ModalFiltroTurmasParams } from '@/enums/eTipoPesquisaFiltroTurmas';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1] | null,
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>;

export interface Actions {
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO](
    { commit }: AugmentedActionContext,
    params: ModalFiltroFuncionariosParams): void;
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO](
    { commit }: AugmentedActionContext): void;
  [ModalActionTypes.ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES](
    { commit }: AugmentedActionContext,
    params: ModalFiltroFuncionariosParams): void;
  [ModalActionTypes.ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES](
    { commit }: AugmentedActionContext): void;
  [ModalActionTypes.ACTION_SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO](
    { commit }: AugmentedActionContext,
    codigoProfessor: number,
  ): void;
  [ModalActionTypes.ACTION_SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO](
    { commit }: AugmentedActionContext,
    nomeProfessor: string,
  ): void;
  [ModalActionTypes.ACTION_RESET_PROFESSOR_SELECIONADO_TELA_FILTRO](
    { commit }: AugmentedActionContext,
  ): void;
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_ESTUDANTE](
    { commit }: AugmentedActionContext,
    params: ModalFiltroEstudantesParams): void;
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_ESTUDANTE](
    { commit }: AugmentedActionContext
  ): void;
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_TURMA](
    { commit }: AugmentedActionContext,
    params: ModalFiltroTurmasParams): void;
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_TURMA](
    { commit }: AugmentedActionContext
  ): void;
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA](
    { commit }: AugmentedActionContext,
    params: ModalFiltroTurmasParams): void;
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA](
    { commit }: AugmentedActionContext
  ): void;
  [ModalActionTypes.ACTION_SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO](
    { commit }: AugmentedActionContext,
    codigoEstudante: number
  ): void;
  [ModalActionTypes.ACTION_SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO](
    { commit }: AugmentedActionContext,
    codigoTurma: string
  ): void;
  [ModalActionTypes.ACTION_SHOW_MODAL_LEGADO](
    { commit }: AugmentedActionContext,
    params: string): void;
  [ModalActionTypes.ACTION_HIDE_MODAL_LEGADO](
    { commit }: AugmentedActionContext): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO]({ commit }, params: ModalFiltroFuncionariosParams) {
    commit(ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_FUNCIONARIO, null);
    commit(ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_FUNCIONARIOS, params.eTipoPesquisaFiltroFuncionarios);
    commit(ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_FUNCIONARIOS, params.route);

    sessionStorage.setItem('eTipoPesquisaFiltroFuncionarios', params.eTipoPesquisaFiltroFuncionarios);
    localStorage.setItem('eTipoPesquisaFiltroFuncionarios', params.eTipoPesquisaFiltroFuncionarios);

    sessionStorage.setItem('routeAfterSelectFiltroFuncionarios', params.route);
    localStorage.setItem('routeAfterSelectFiltroFuncionarios', params.route);
  },
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO]({ commit }) {
    commit(ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_FUNCIONARIO, null);
  },
  [ModalActionTypes.ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES]({ commit }) {
    commit(ModalMutationTypes.ACTION_SHOW_MODAL_AVISOS_NOTIFICACOES, null);
  },
  [ModalActionTypes.ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES]({ commit }) {
    commit(ModalMutationTypes.ACTION_HIDE_MODAL_AVISOS_NOTIFICACOES, null);
  },
  [ModalActionTypes.ACTION_SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO]({ commit }, codigoProfessorSelectedTelaFiltro: number) {
    sessionStorage.setItem('codigoProfessorSelectedTelaFiltro', codigoProfessorSelectedTelaFiltro.toString());
    localStorage.setItem('codigoProfessorSelectedTelaFiltro', codigoProfessorSelectedTelaFiltro.toString());
    commit(ModalMutationTypes.SET_CODIGOPROFESSOR_SELECIONADO_TELA_FILTRO, codigoProfessorSelectedTelaFiltro);
  },
  [ModalActionTypes.ACTION_SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO]({ commit }, nomeProfessorSelectedTelaFiltro: string) {
    sessionStorage.setItem('nomeProfessorSelectedTelaFiltro', nomeProfessorSelectedTelaFiltro.toString());
    localStorage.setItem('nomeProfessorSelectedTelaFiltro', nomeProfessorSelectedTelaFiltro.toString());
    commit(ModalMutationTypes.SET_NOMEPROFESSOR_SELECIONADO_TELA_FILTRO, nomeProfessorSelectedTelaFiltro);
  },
  /**
   * Limpa o professor selecionado pela supervisão. Tem de apagar sessionStorage E localStorage: o
   * state é reconstruído deles a cada carga da página, então zerar só o state em memória fazia o
   * professor voltar no próximo F5.
   */
  [ModalActionTypes.ACTION_RESET_PROFESSOR_SELECIONADO_TELA_FILTRO]({ commit }) {
    sessionStorage.removeItem('codigoProfessorSelectedTelaFiltro');
    localStorage.removeItem('codigoProfessorSelectedTelaFiltro');
    sessionStorage.removeItem('nomeProfessorSelectedTelaFiltro');
    localStorage.removeItem('nomeProfessorSelectedTelaFiltro');
    commit(ModalMutationTypes.RESET_PROFESSOR_SELECIONADO_TELA_FILTRO, undefined);
  },
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_ESTUDANTE]({ commit }, params: ModalFiltroEstudantesParams) {
    commit(ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_ESTUDANTE, null);
    commit(ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_ESTUDANTES, params.eTipoPesquisaFiltroEstudantes);
    commit(ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_ESTUDANTES, params.route);

    sessionStorage.setItem('eTipoPesquisaFiltroEstudantes', params.eTipoPesquisaFiltroEstudantes);
    localStorage.setItem('eTipoPesquisaFiltroEstudantes', params.eTipoPesquisaFiltroEstudantes);

    sessionStorage.setItem('routeAfterSelectFiltroEstudantes', params.route);
    localStorage.setItem('routeAfterSelectFiltroEstudantes', params.route);
  },
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_ESTUDANTE]({ commit }) {
    commit(ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_ESTUDANTE, null);
  },
  [ModalActionTypes.ACTION_SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO]({ commit }, codigoEstudante: number) {
    sessionStorage.setItem('codigoEstudanteSelectedTelaFiltro', codigoEstudante.toString());
    localStorage.setItem('codigoEstudanteSelectedTelaFiltro', codigoEstudante.toString());
    commit(ModalMutationTypes.SET_CODIGOESTUDANTE_SELECIONADO_TELA_FILTRO, codigoEstudante);
  },
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_TURMA]({ commit }, params: ModalFiltroTurmasParams) {
    commit(ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_TURMA, null);
    commit(ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_TURMAS, params.eTipoPesquisaFiltroTurmas);
    commit(ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_TURMAS, params.route);

    sessionStorage.setItem('eTipoPesquisaFiltroTurmas', params.eTipoPesquisaFiltroTurmas);
    localStorage.setItem('eTipoPesquisaFiltroTurmas', params.eTipoPesquisaFiltroTurmas);

    sessionStorage.setItem('routeAfterSelectFiltroTurmas', params.route);
    localStorage.setItem('routeAfterSelectFiltroTurmas', params.route);

    sessionStorage.setItem('parametrosTelaEnturmacao', params.parametrosTelaEnturmacao);
    localStorage.setItem('parametrosTelaEnturmacao', params.parametrosTelaEnturmacao);
  },
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_TURMA]({ commit }) {
    commit(ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_TURMA, null);
  },
  [ModalActionTypes.ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA]({ commit }, params: ModalFiltroTurmasParams) {
    commit(ModalMutationTypes.ACTION_SHOW_MODAL_FILTRO_MULTI_TURMA, null);
    commit(ModalMutationTypes.SET_TIPOPESQUISA_TELA_FILTRO_TURMAS, params.eTipoPesquisaFiltroTurmas);
    commit(ModalMutationTypes.SET_ROTA_CHAMAR_FILTRO_TURMAS, params.route);

    sessionStorage.setItem('eTipoPesquisaFiltroTurmas', params.eTipoPesquisaFiltroTurmas);
    localStorage.setItem('eTipoPesquisaFiltroTurmas', params.eTipoPesquisaFiltroTurmas);

    sessionStorage.setItem('routeAfterSelectFiltroTurmas', params.route);
    localStorage.setItem('routeAfterSelectFiltroTurmas', params.route);
  },
  [ModalActionTypes.ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA]({ commit }) {
    commit(ModalMutationTypes.ACTION_HIDE_MODAL_FILTRO_MULTI_TURMA, null);
  },
  [ModalActionTypes.ACTION_SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO]({ commit }, codigoTurma: string) {
    sessionStorage.setItem('codigoTurmaSelectedTelaFiltro', codigoTurma.toString());
    localStorage.setItem('codigoTurmaSelectedTelaFiltro', codigoTurma.toString());
    commit(ModalMutationTypes.SET_CODIGOTURMA_SELECIONADA_TELA_FILTRO, codigoTurma);
  },
  [ModalActionTypes.ACTION_SHOW_MODAL_LEGADO]({ commit }, params: string) {
    commit(ModalMutationTypes.ACTION_SHOW_MODAL_LEGADO, null);
    sessionStorage.setItem('telaLegado', params);
    localStorage.setItem('telaLegado', params);
  },
  [ModalActionTypes.ACTION_HIDE_MODAL_LEGADO]({ commit }) {
    commit(ModalMutationTypes.ACTION_HIDE_MODAL_LEGADO, null);
  },
};
